import { makeAutoObservable, runInAction } from "mobx";
import { ResourcesList } from "generated";

export interface DroppedImage {
  id: string;
  src: string;
  x: number;
  y: number;
  linkedElementId?: string;
  propertysubtypes?: string;
  setvalue?: string;
  top?: number;
  left?: number;
  priority: number;
  height: number;
  width: number;
  timestamp: number;
  group?: string;
  origin?: "mark" | "poster";
  linkSide?: string;
  controlId?: string;
  hidden?: boolean;
  targetSide?: "left" | "right" | "top" | "bottom";
  comment: string;
  commentDate: any;
  commentAuthor: string;
  windowId: any;
}

export type Mark = {
  id: string;
  name: string;
  text?: string;
}

export class MarkStore {
  marks: any[] = [];
  notes: any[] = [];
  droppedImages: DroppedImage[] = [];
  isOpen: boolean = false;
  connectionlinecolor: string = "#216aff";
  selectionoutlinecolor: string = "#216aff";
  isMarkControl: boolean = true;
  id: string;

  constructor() {
    makeAutoObservable(this);
  }

  openModal(posters: Mark[] = [], notes: Mark[] = []) {
    this.marks = posters; 
    this.notes = notes; 
    this.isOpen = true;
  }

  closeModal() {
    this.isOpen = false;
  }

  toJSON() {
    return {
      id: this.id,
      droppedImages: this.droppedImages.map(img => ({ ...img })),
    };
  }

  hydrateFromJSON(data: any) {
    runInAction(() => {
      this.droppedImages = data.droppedImages || [];
    });
  }

  removeImage(img: DroppedImage) {
    const id = String(img?.id ?? "");
    if (!id) return;
    this.droppedImages = this.droppedImages.filter(i => String(i.id) !== id);
  }

  findMarkBySrc(src: string) {
    const cleanSrc = src.replace("/resources/", "");
    const entry = Object.entries(ResourcesList.resourcesList).find(
      ([, value]) => value === cleanSrc
    );

    if (!entry) return undefined;
    const [resourcename] = entry;
    const shortName = resourcename.split(".").pop()?.replace(/^\d+_ /, "") || "Без названия";

    return {
      name: shortName,
      resourcename
    };
  }
}

export class MarkData {
  marksData:any[] = [];
}

export const markStore = new MarkStore();
export const marksData = new MarkData();
